export default {
    namespaced: true,
    state: {
        name: null,
        dialog: false,
        width: 500
    },

    mutations: {
        change(state, val){
            state.dialog = val;
        },
        setSettings(state, settings){
            state.width = settings.width;
        },
        setName(state, name){
            state.name = name;
        }
    },

    getters: {
        dialog: state => state.dialog,
        width: state => state.width,
        name: state => state.name,
    },

    actions: {
        setDefaultSettings({commit}){
            commit('setSettings', {width: 500});
        },
        show({commit}){
            commit('change', true);
        },
        hide({commit}){
            commit('change', false);
        },
        toggle({ getters, commit }){
            commit('change', !getters.dialog);
        },
        showWorkSpaceCreateModal({commit, dispatch}){
            commit('setName', 'WorkSpaceCreateModal');
            dispatch('show');
        },
        showWorkSpaceInviteModal({commit, dispatch}){
            commit('setName', 'WorkSpaceInviteDialog');
            commit('setSettings', {width: 800});
            dispatch('show');
        }
    }
}